import dayjs from 'dayjs';

const isDev = window.location.hostname === 'localhost';
const isQLD = window.location.hostname.includes('bodycorporateinfo');


export const initialFormValues = {
    state: isQLD ? "QLD" : "NSW",
    dpNumber: isDev ? '24154' : "",
    lotNumber: isDev ? '14' : "",
    brand: isDev ? 'BCS Coolangatta & Tweed Heads' : "",
    firstName: isDev ? 'John' : "",
    lastName: isDev ? 'Doe' : "",
    email: isDev ? 'adam@refactor.com.au' : "",
    contactNumber: isDev ? '1234567890' : "",
    address: isDev ? '110 KORTUM DRIVE ' : "",
    suburb: isDev ? 'BURLEIGH HEADS' : "",
    postcode: isDev ? '4220' : "",
    country: "Australia",
    statusToRecords: isDev ? 'prospective_lot_buyer' : "",
    files: [],
    agencyName: isDev ? 'My Agency' : "",
    // agentFirstName: isDev ? 'John' : "",
    // agentLastName: isDev ? 'Doe' : "",
    // agentEmail: isDev ? 'john.doe@example.com' : "",
    // agentContactNumber: isDev ? '1234567890' : "",
    date: dayjs(new Date()),
    hours: isQLD ? 2 : 1,
    readAndAccepted: false
}


// export const initialFormValues = {
//     state: "NSW",
//     dpNumber: isDev ? '1297' : "",
//     lotNumber: isDev ? '1' : "",
//     brand: isDev ? 'Dynamic Property Services' : "",
//     firstName: isDev ? 'John' : "",
//     lastName: isDev ? 'Doe' : "",
//     email: isDev ? 'skip@refactor.com.au' : "",
//     contactNumber: isDev ? '1234567890' : "",
//     address: isDev ? '66 Bayswater Road' : "",
//     suburb: isDev ? 'Rushcutters Bay' : "",
//     postcode: isDev ? '2011' : "",
//     country: "Australia",
//     statusToRecords: isDev ? 'lot_owner' : "",
//     files: [],
//     agencyName: isDev ? 'My Agency' : "",
//     agentFirstName: isDev ? 'John' : "",
//     agentLastName: isDev ? 'Doe' : "",
//     agentEmail: isDev ? 'john.doe@example.com' : "",
//     agentContactNumber: isDev ? '1234567890' : "",
//     date: dayjs(new Date()),
//     hours: 3,
//     readAndAccepted: false
// }

// export const initialFormValues = {
//     state: isQLD ? "QLD" : "NSW",
//     dpNumber: isDev ? '33123' : "",
//     lotNumber: isDev ? '1' : "",
//     brand: isDev ? 'BCS Strata Gosford' : "",
//     firstName: isDev ? 'John' : "",
//     lastName: isDev ? 'Doe' : "",
//     email: isDev ? 'skip@refactor.com.au' : "",
//     contactNumber: isDev ? '1234567890' : "",
//     address: isDev ? '101 PUR PUR AVENUE' : "",
//     suburb: isDev ? 'LAKE ILLAWARRA' : "",
//     postcode: isDev ? '2528' : "",
//     country: "Australia",
//     statusToRecords: isDev ? 'lot_owner' : "",
//     files: [],
//     agencyName: isDev ? 'My Agency' : "",
//     agentFirstName: isDev ? 'John' : "",
//     agentLastName: isDev ? 'Doe' : "",
//     agentEmail: isDev ? 'john.doe@example.com' : "",
//     agentContactNumber: isDev ? '1234567890' : "",
//     date: dayjs(new Date()),
//     hours: 3,
//     readAndAccepted: false
// }

export const initialPaymentValues =
{
    cardNumber: isDev ? "4111111111111111" : "", // Default Visa test card number
    cardName: isDev ? "Test User" : "",          // Placeholder cardholder name
    expiryMonth: isDev ? "12" : "",              // Default expiry month
    expiryYear: "",               // Default expiry year   isDev ? "26" : 
    cvn: isDev ? "123" : "",                     // Default CVN
    billingAddress: isDev ? '1234 Main St' : "",
    billingSuburb: isDev ? 'Anytown' : "",
    billingPostcode: isDev ? '4215' : "", // Must be valid postcode
    billingState: isQLD ? "QLD" : "NSW",
    billingCountry: "AU" //  2-letter ISO country code 
}